import React from 'react';
import DefaultLayout from '../../layouts/DefaultLayout';

const ErrorElement = () => {
  return <DefaultLayout>ErrorElement</DefaultLayout>;
};

export default ErrorElement;
